import React, { useMemo } from "react";

function pretty(kind) {
  const k = String(kind || "").toUpperCase();
  if (k === "COC_FORM") return "CoC form";
  if (k === "BANK_STATEMENT") return "Bank statement";
  if (k === "PASSPORT") return "Passport";
  if (k === "CRIB_NUMMER") return "CRIB number";
  if (k === "FINANCIAL_STATEMENTS") return "Financial Statements";
  if (k === "VESTIGINGS_VERGUNNING") return "Vestigingsvergunning";
  if (k === "DEVIEZEN_VRIJSTELLING") return "Deviezenvrijstelling";
  return kind || "—";
}

function isExpired(expires_on) {
  if (!expires_on) return false;
  const d = new Date(expires_on);
  return Number.isFinite(d.getTime()) && d < new Date();
}

export default function RequiredDocsPanel({ requirements, docs, roles }) {
  const req = requirements || { company: [], ubo: [] };

  const { ubos, companyDocMap, uboDocMaps } = useMemo(() => {
    const ubos = (roles || [])
      .filter((r) => String(r.role).toLowerCase() === "ubo")
      .map((r) => ({
        person_id: r.person_id ?? r.person?.id ?? null,
        name: (r.person?.first_name || r.first_name || "") + (r.person?.last_name || r.last_name ? " " + (r.person?.last_name || r.last_name) : ""),
      }));

    const companyDocMap = new Map();
    (docs || []).forEach((d) => {
      const kind = String(d.kind || "").toUpperCase();
      if (!d.person_id) {
        if (!companyDocMap.has(kind)) companyDocMap.set(kind, []);
        companyDocMap.get(kind).push(d);
      }
    });

    const indexByPersonId = new Map();
    ubos.forEach((u, i) => u.person_id != null && indexByPersonId.set(u.person_id, i));

    const uboDocMaps = ubos.map(() => new Map());
    (docs || []).forEach((d) => {
      const pid = d.person_id ?? null;
      if (pid == null) return;
      if (!indexByPersonId.has(pid)) return;
      const idx = indexByPersonId.get(pid);
      const kind = String(d.kind || "").toUpperCase();
      if (!uboDocMaps[idx].has(kind)) uboDocMaps[idx].set(kind, []);
      uboDocMaps[idx].get(kind).push(d);
    });

    return { ubos, companyDocMap, uboDocMaps };
  }, [docs, roles]);

  const items = [];

  (req.company || []).forEach((k) => {
    const kind = String(k).toUpperCase();
    const matches = companyDocMap.get(kind) || [];
    const valid = matches.some((m) => !isExpired(m.expires_on));
    items.push({
      label: `Company: ${pretty(kind)}`,
      status: valid ? "ok" : matches.length ? "expired" : "missing",
    });
  });

  (req.ubo || []).forEach((k) => {
    const kind = String(k).toUpperCase();
    ubos.forEach((u, i) => {
      const matches = (uboDocMaps[i] && uboDocMaps[i].get(kind)) || [];
      const valid = matches.some((m) => !isExpired(m.expires_on));
      items.push({
        label: `UBO #${i + 1}${u.name ? ` (${u.name})` : ""}: ${pretty(kind)}`,
        status: valid ? "ok" : matches.length ? "expired" : "missing",
      });
    });
  });

  if (!items.length) return null;

  return (
    <div className="card" style={{ padding: 16, marginTop: 16 }}>
      <h3>Required documents</h3>
      <ul style={{ margin: 0, paddingLeft: 18 }}>
        {items.map((it, idx) => (
          <li key={idx} style={{ margin: "6px 0" }}>
            {it.status === "ok" ? "✅" : it.status === "expired" ? "⚠️" : "❌"} {it.label}
            {it.status === "expired" && <em style={{ marginLeft: 6, opacity: 0.8 }}>— expired</em>}
            {it.status === "missing" && <em style={{ marginLeft: 6, opacity: 0.8 }}>— missing</em>}
          </li>
        ))}
      </ul>
    </div>
  );
}
